import React from 'react'
import Ques from '../../components/admin/questions'
export default function Questions() {
  return (
    <div>
        <Ques/>
    </div>
  )
}
